import { useMemo } from 'react';
import { SavedState } from '@/components/team-details/types/selector-types';

export const useTeamOpponents = (savedStates: SavedState[] | null, teamName: string | undefined) => {
  return useMemo(() => {
    if (!savedStates || !teamName) return [];
    const teams = new Set<string>();
    
    savedStates.forEach(state => {
      if (Array.isArray(state.data)) {
        state.data.forEach(match => {
          if (match.HomeTeam !== teamName) teams.add(match.HomeTeam);
          if (match.AwayTeam !== teamName) teams.add(match.AwayTeam);
        });
      }
    });
    
    return Array.from(teams).sort();
  }, [savedStates, teamName]);
};